"use client"

import { motion } from "framer-motion"
import { useEffect, useState } from "react"
import { useAuth } from "../context/AuthContext"
import { BASE_LOGIN_URL } from "../../config"
import { Navigate } from "react-router"

const ProtectedRoute = ({ children, forAdmin }) => {
  const { isAuthenticated, loading,user } = useAuth()
  const [redirecting, setRedirecting] = useState(false)

  const redirectToAuth = () => {
    setRedirecting(true)
    const currentUrl = window.location.href
    const encodedRedirect = encodeURIComponent(currentUrl)
    setTimeout(() => {
      window.location.href = `${BASE_LOGIN_URL}?redirectTo=${encodedRedirect}`
    }, 1000)
  }

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      console.warn("❌ User not authenticated. Redirecting...")
      redirectToAuth()
    }
  }, [loading, isAuthenticated])

  if (loading || redirecting) {
    return (
      <div className="fixed inset-0 bg-white/80 backdrop-blur-sm flex justify-center items-center z-50">
        <motion.div
          className="bg-white/90 p-8 rounded-2xl border border-white/10 shadow-xl max-w-md w-full"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
        >
          <div className="flex flex-col items-center">
            <motion.div
              className="mb-6 relative"
              animate={{ rotate: 360 }}
              transition={{
                repeat: Number.POSITIVE_INFINITY,
                duration: 3,
                ease: "linear",
              }}
            >
              <div className="absolute inset-0 rounded-full bg-gradient-to-r from-primary to-secondary blur-md opacity-50"></div>
              <div className="relative flex items-center justify-center w-16 h-16 rounded-full bg-[#1A1A1A] border border-white/10">
                {/* <img src={RockstarLogo || "/placeholder.svg"} alt="Logo" className="w-10 h-10" /> */}
                image
              </div>
            </motion.div>

            <motion.h2
              className="text-xl font-semibold mb-3 text-black"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
            >
              {redirecting ? "Redirecting to Login" : "Validating Session"}
            </motion.h2>

            <motion.div
              className="w-full bg-white/5 rounded-full h-1.5 mb-4 overflow-hidden"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <motion.div
                className="bg-gradient-to-r from-primary to-secondary h-full"
                initial={{ width: "0%" }}
                animate={{ width: "100%" }}
                transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY }}
              />
            </motion.div>

            <motion.p
              className="text-black/70 text-sm"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              {redirecting
                ? "You will be redirected to the login page in a moment..."
                : "Please wait while we verify your credentials..."}
            </motion.p>
          </div>
        </motion.div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return null
  }

  if (forAdmin && isAuthenticated && user.role !== "admin") {
    return <Navigate to="/dashboard" />;
  }

  return children
}

export default ProtectedRoute
